module.exports = __webpack_public_path__ + "img/xzgj_3.d27d3ecf.png";